const Bars = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 34 34"
		fill="none"
		{...props}
	>
		<path
			stroke="#1BB052"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={3}
			d="M2 18.875C2 17.84 2.84 17 3.875 17h3.75c1.035 0 1.875.84 1.875 1.875v11.25C9.5 31.16 8.66 32 7.625 32h-3.75A1.875 1.875 0 0 1 2 30.125v-11.25Zm11.25-7.5c0-1.035.84-1.875 1.875-1.875h3.75c1.035 0 1.875.84 1.875 1.875v18.75c0 1.035-.84 1.875-1.875 1.875h-3.75a1.875 1.875 0 0 1-1.875-1.875v-18.75Zm11.25-7.5C24.5 2.84 25.34 2 26.375 2h3.75C31.16 2 32 2.84 32 3.875v26.25C32 31.16 31.16 32 30.125 32h-3.75a1.875 1.875 0 0 1-1.875-1.875V3.875Z"
		/>
	</svg>
);
export default Bars;
